// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"22b8eacb","133":"9173aab9","205":"82bda555","210":"34396dd0","611":"82bda555","663":"5fd1a89b","665":"4c1e5347","727":"bd8d49da","763":"1408a85d"}[chunkId] + ".chunk.css";
};